import React, { Component } from 'react';
import './style.scss';
import { Popconfirm, Table } from 'antd';
import { getFeetbacks, deleteFeedback } from './actions';
import PropTypes from 'prop-types'
import moment from 'moment';
import { CloseOutlined, QuestionCircleOutlined } from '@ant-design/icons';

class TeacherFeetback extends Component {
  static contextTypes = {formatMessage: PropTypes.any}
  constructor(props) {
    super(props);
    this.state = {
      spinner: true,
      data: []
    };
  }

  async componentDidMount() {
    try {
       const data = await getFeetbacks();
       this.setState({
         spinner: false,
         data,
       })
    } catch (error) {
      
    }
  }

  render() {
    const { spinner, data } = this.state;
    const {formatMessage} = this.context;

    const columns = [
      {
        title: formatMessage('tbTeacherName'),
        dataIndex: 'user.username',
        key: 'username',
      },
      {
        title: formatMessage('tbTeacherEmail'),
        dataIndex: 'user.email',
        key: 'email',
      },
      {
        title: formatMessage('tbTeacherFeetbackStars'),
        dataIndex: 'stars',
        key: 'stars',
      },
      {
        title: formatMessage('tbTeacherFeetbackContent'),
        dataIndex: 'content',
        key: 'content',
      },
      {
        title: formatMessage('tbTeacherFeetbackCreatedAt'),
        dataIndex: 'created_at',
        key: 'created_at',
        render: (value) => moment.unix(value).format('LLL')
      },
      {
        title: '',
        render: (item) => {
          return <div className="actions-table">
            <Popconfirm
              title={formatMessage('msgDeleteFeedback')}
              icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
              onConfirm={ async() => {
                // const { room } = this.props;
                // await this.props.deleteRoomStudent({
                //   room_id: room.id,
                //   student_id: item.id,
                // });

                try {
                  this.setState({spinner: true})
                  await deleteFeedback(item.id);
                  this.setState({
                    data: data.filter(_i => _i.id != item.id),
                    spinner: false
                  })
                } catch (error) {
                  this.setState({spinner: false})
                  
                }

                
              }}
            >
              <CloseOutlined />
            </Popconfirm>
          </div>
        },
        key: 'actions',
      },
    ]

    return (
      <div className="AdminFeetback row">
        <div className="col-md-12">
          <Table loading={spinner} dataSource={data} columns={columns} bordered />
        </div>
      </div>
    );
  }
}

export default TeacherFeetback;



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/AdminPanel/TeacherFeetback/index.js